/* ============
 * Send purchase
 * ============
 *
 * Send purchase email
 */

import Vue from 'vue';
import purchaseMessageTransformer from './../../transformers/purchaseMessage';

export default (id, previewParams) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`purchases/${id}/send`, purchaseMessageTransformer.send(previewParams))
    .then(() => {
      resolve();
    })
    .catch(() => {
      reject();
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/send.js